import { OrderStatus } from '@/entities/api/orders/orders'

export function OrderStatusConvert(status: OrderStatus): string {
	switch (status) {
		case OrderStatus.new:
			return 'Nueva'
		case OrderStatus.pending:
			return 'Pendiente'
		case OrderStatus.processing:
			return 'En proceso'
		case OrderStatus.on_the_way:
			return 'En camino'
		case OrderStatus.rejected:
			return 'Rechazada'
		case OrderStatus.delivered:
			return 'Entregada'
		case OrderStatus.refunded:
			return 'Reembolso'
		default:
			return 'Estado desconocido'
	}
}

export function OrderStatusColor(status: OrderStatus): string {
	switch (status) {
		case OrderStatus.new:
			return '#2D81E0FF'
		case OrderStatus.pending:
			return '#F5A623'
		case OrderStatus.processing:
			return '#71C716FF'
		case OrderStatus.on_the_way:
			return '#1DD1AAFF'
		case OrderStatus.rejected:
			return '#D0021B'
		case OrderStatus.delivered:
			return '#417505'
		case OrderStatus.refunded:
			return '#FF6600FF'
		default:
			return '#9B9B9B'
	}
}
